import React from 'react';
import { COLORS, FONT, RADIUS } from '../shared/tokens';
import { formatDisplayWeek, formatAmount } from '../../../helper';

/* Shared Recharts tooltip — matches the admin card look (white, hairline border,
   soft shadow). `week` renders the label as a friendly date range; `prefix`
   defaults to the £ money format, pass prefix="" for plain counts. */
export default function ChartTooltip({ active, payload, label, week = false, prefix = '£' }) {
    if (!active || !payload || !payload.length) return null;
    const heading = week ? formatDisplayWeek(label) : label;
    return (
        <div style={{
            background: COLORS.surface, border: `1px solid ${COLORS.border}`,
            borderRadius: RADIUS.card, padding: '10px 14px', fontFamily: FONT, fontSize: 12,
            boxShadow: '0 6px 20px rgba(16,24,40,0.14)', minWidth: 140,
        }}>
            {heading && <div style={{ color: COLORS.textDim, marginBottom: 6, fontWeight: 600 }}>{heading}</div>}
            {payload.map((p, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, color: COLORS.text, fontWeight: 600, padding: '1px 0' }}>
                    <span style={{ width: 8, height: 8, borderRadius: 2, background: p.color || p.fill, flexShrink: 0 }} />
                    <span style={{ textTransform: 'capitalize' }}>{p.name}</span>
                    <span style={{ marginLeft: 'auto' }}>{prefix}{prefix ? formatAmount(p.value) : p.value}</span>
                </div>
            ))}
        </div>
    );
}
